import { useLocation } from "react-router-dom";
import React from "react";

export default function MainWrapper({ children}) {
  const location = useLocation();
  const paddingTop = location.pathname === "/" ? "pt-[2rem]" : "pt-[12rem]";
  return <main className={`flex-grow ${paddingTop}`}>{children}</main>;
}
